import actions from './actions'
import mutations from './mutations'

function state() {
  return {
    users: [],
    filter: null,
    targetFilter: null,
    datasets: null, // contains the datasets that are used in the Workbench and Attribute Panel
    datasetFamilies: null, // contains the dataset families json that organizes the datasets used in the workbench and attribute panel together
    dayParts: null,
    minStartMonths: {
      mri: null,
      ncs: null,
      amrld: null,
    },
    maxEndMonths: {
      mri: null,
      ncs: null,
      amrld: null,
    },
    dateRanges: [], // the set of date ranges excepted by LAS targets
    primaryInsightsFilter: [],
    byodDataset: null,
    sourceConstants: null,
    mvpds: null,
    videoAmpAudienceList: null,
  }
}

const getters = {
  quickAddAttributes: (state, getters) => {
    return state.quickAddAttributes ? state.quickAddAttributes.map(getters.getAttributesForIdDataset) : []
  },
  getAttributesForIdDataset: state => {
    return ({ id, dataset }) => {
      const amrldDataset = state.datasets.find(dataset => dataset.data.id === 'amrld')
      const dataSetSource = amrldDataset.data.children.find(data => data.id === dataset)
      const found = dataSetSource.children.find(data => data.id === id)
      if (found) return found
      return false
    }
  },
  primaryInsightsFilter: state => {
    return state.primaryInsightsFilter
  },
  getBYODDataset: state => {
    return state.byodDataset
  },
  getConstants: state => {
    return state.sourceConstants
  },
  getC360Datasources: state => {
    return state.sourceConstants && state.sourceConstants.DATASOURCES ? state.sourceConstants.DATASOURCES.C360 : {}
  },
  getNielsenDatasources: state => {
    return state.sourceConstants && state.sourceConstants.DATASOURCES ? state.sourceConstants.DATASOURCES.NIELSEN : {}
  },
}

const module = {
  state,
  getters,
  mutations,
  actions,
}

export default module



// WEBPACK FOOTER //
// ./src/app/store/modules/applicationResources/index.js